import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDate, inr } from "@/lib/format";

export default function Customers() {
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    api.get("/admin/customers").then((r) => setCustomers(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-4" data-testid="admin-customers-page">
      <h1 className="font-heading text-2xl font-bold tracking-tight">Customers</h1>
      <div className="bg-white border border-neutral-200 overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead>
            <tr className="text-left text-[11px] font-mono uppercase tracking-widest text-neutral-500 border-b border-neutral-200">
              <th className="p-3">Customer</th><th className="p-3">Phone</th><th className="p-3">Orders</th>
              <th className="p-3 text-right">Lifetime Value</th><th className="p-3">Last Order</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((c) => (
              <tr key={c.email} className="border-b border-neutral-100" data-testid={`customer-row-${c.email.replace(/[^a-z0-9]/gi, "-")}`}>
                <td className="p-3">
                  <p className="font-medium">{c.name || "—"}</p>
                  <p className="text-xs text-neutral-400">{c.email}</p>
                </td>
                <td className="p-3 font-mono text-xs">{c.phone || "—"}</td>
                <td className="p-3 font-mono">{c.order_count}</td>
                <td className="p-3 text-right font-medium" data-testid={`ltv-${c.email.replace(/[^a-z0-9]/gi, "-")}`}>{inr(c.ltv)}</td>
                <td className="p-3 text-neutral-500">{c.last_order ? fmtDate(c.last_order) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {customers.length === 0 && <p className="p-6 text-center text-sm text-neutral-500" data-testid="no-customers">No customers yet.</p>}
      </div>
    </div>
  );
}
